import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment.prod';
import { NotificationService } from './notification.service';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {
  public email: string;
  public screenMaster: any = [];
  constructor(private injector: Injector, private route: Router, private notify: NotificationService,private restService: RestService) {
  }
  intercept(req, next) {
    const restService = this.injector.get(RestService);
    const token = req.clone({
      setHeaders: {
        Authorization: restService.getToken() != null ? restService.getToken() : 'null',
      },
    });
    return next.handle(token).pipe(catchError(err => {
      if (err.status === 401) {
        this.notify.showError('Authentication Error !!!', '');
        this.route.navigateByUrl('/401-page');
      } else if(err.status === 504){
        this.notify.showError("Gateway Timeout server !!!","");
      }
      const error = err.error.message || err.statusText;
      return throwError(error);
    }));
  }
}
